// extracted by mini-css-extract-plugin
module.exports = {"root":"EditHeader_root__YnlcF","title":"EditHeader_title__3rg1C","cancel":"EditHeader_cancel__LAxJx"};